import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

import rootReducer from './reducers'

const middleware = applyMiddleware(thunk)

// @ts-expect-error leave as is
const store = createStore(rootReducer, composeWithDevTools(middleware))

export default store
